export default __webpack_public_path__ + "static/media/greentick.f75977f0.png";